export const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://bugtracker-server.onrender.com'
    : 'https://localhost:44362';
